(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
// Desktop only: load + autoplay the hero video. Phones never fetch it (LCP stays the poster).
(function () {
  var dv = document.querySelector('[data-hero-desktop]');
  if (dv && window.matchMedia('(min-width: 750px)').matches) {
    var s = dv.getAttribute('data-src');
    if (s) { dv.src = s; dv.autoplay = true; dv.load(); var pl = dv.play(); if (pl && pl.catch) { pl.catch(function () {}); } }
  }
})();
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-hero-play]');
  if (!btn) return;
  var wrap = btn.closest('[data-hero-mobile]');
  var src = btn.getAttribute('data-hero-video');
  if (!wrap || !src) return;
  if (wrap.querySelector('video')) return;
  var v = document.createElement('video');
  v.className = 'hero__video';
  v.src = src;
  v.muted = true; v.loop = true; v.autoplay = true;
  v.setAttribute('playsinline', ''); v.playsInline = true;
  wrap.appendChild(v);
  wrap.classList.add('is-playing');
  var p = v.play();
  if (p && p.catch) { p.catch(function () {}); }
});

  } catch(e) { console.error(e); }
})();
})();
